import { Checkbox } from "@/components/ui/checkbox";
import { useConfigStore } from "../../../../store/configStore";
import { useEditorStore } from "../../../../store/editorStore";
import {
  getSelectionRequireCategories,
  isSelectionLayerRequired,
} from "../../../../lib/selectionUtils";
import { SelectionData } from "../../../../types/selection";

/**
 * Selection 行上的必选勾选：
 * - 写入层字段 opt（false=必选）
 * - 联动 requireCategories（假定一类一层）
 */
export function SelectionRequiredCheckbox({
  selection,
}: {
  selection: SelectionData;
}) {
  const skus = useConfigStore((s) => s.templateConfig?.skus);
  const setSelectionRequired = useEditorStore((s) => s.setSelectionRequired);

  const categories = getSelectionRequireCategories(selection, skus);
  const checked = isSelectionLayerRequired(selection);

  return (
    <div
      role="button"
      tabIndex={0}
      className="flex items-center gap-1 shrink-0"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      title={
        checked
          ? categories.length > 0
            ? `必选层（联动 category: ${categories.join(", ")}）`
            : "必选层"
          : categories.length > 0
            ? `设为必选（将写入 category: ${categories.join(", ")}）`
            : "设为必选层（暂无 SKU 时仅写层字段，有 SKU 后会联动 category）"
      }
    >
      <Checkbox
        checked={checked}
        onCheckedChange={(value) => {
          setSelectionRequired(selection.id, value === true);
        }}
        className="shrink-0"
      />
      <span className="text-[10px] text-muted-foreground">必选</span>
    </div>
  );
}
